define('Jajuma_ImageOptimizerUltimate/js/swatch-renderer-mixin',[
    'jquery',
    'mage/storage',
    'underscore',
    'jquery-ui-modules/widget',
    "domReady!"
], function ($, storage, _) {
    'use strict';

    if (JajumaUIO.isEnabled) {
        window.loadModernizr();
    }
    return function (widget) {
        $.widget('mage.SwatchRenderer', widget, {
            updateBaseImage: function (images, context, isInProductView) {
                if (!JajumaUIO.isEnabled) {
                    return this._super(images, context, isInProductView);
                }
                var justAnImage = images[0],
                    initialImages = this.options.mediaGalleryInitial,
                    imagesToUpdate,
                    gallery = context.find(this.options.mediaGallerySelector).data('gallery'),
                    isInitial,
                    self = this;

                if (isInProductView) {
                    if (_.isUndefined(gallery)) {
                        context.find(this.options.mediaGallerySelector).on('gallery:loaded', function () {
                            this.updateBaseImage(images, context, isInProductView);
                        }.bind(this));

                        return;
                    }

                    imagesToUpdate = images.length ? this._setImageType($.extend(true, [], images)) : [];
                    isInitial = _.isEqual(
                        imagesToUpdate.map(({thumb, img, full, type, videoUrl}) => ({thumb, img, full, type, videoUrl})),
                        initialImages.map(({thumb, img, full, type, videoUrl}) => ({thumb, img, full, type, videoUrl}))
                    );

                    if (this.options.gallerySwitchStrategy === 'prepend' && !isInitial) {
                        imagesToUpdate = imagesToUpdate.concat(initialImages);
                    }

                    imagesToUpdate = this._setImageIndex(imagesToUpdate);

                    ModernizrJajuma.on('avif', function(checkAvif) {
                        if (checkAvif) {
                            ModernizrJajuma.on('webp', function (result) {
                                if (result) {
                                    // custom replace images with webp images
                                    self._convertOptimizeImage(imagesToUpdate, context, isInProductView, justAnImage, 'both', ()=>{
                                        self._addFotoramaVideoEvents(isInitial);
                                    });

                                } else {
                                    gallery.updateData(imagesToUpdate);
                                    self._addFotoramaVideoEvents(isInitial);
                                }
                            });
                        } else {
                            ModernizrJajuma.on('webp', function (result) {
                                if (result) {
                                    // custom replace images with webp images
                                    self._convertOptimizeImage(imagesToUpdate, context, isInProductView, justAnImage, 'webp', ()=>{
                                        self._addFotoramaVideoEvents(isInitial);
                                    });
                                    self._addFotoramaVideoEvents(isInitial);
                                } else {
                                    gallery.updateData(imagesToUpdate);
                                    self._addFotoramaVideoEvents(isInitial);
                                }
                            });
                        }
                    })

                } else if (justAnImage && justAnImage.img) {
                    ModernizrJajuma.on('avif', function (checkAvif) {
                        if (checkAvif) {
                            ModernizrJajuma.on('webp', function (result) {
                                if (result) {
                                    // custom replace images with webp images
                                    self._convertOptimizeImage(images, context, isInProductView, justAnImage, 'both');
                                    //Still need to update image/jpg here
                                    // context.find('[type="image/jpg"]').attr('srcset', justAnImage.img);
                                    // context.find('[type="image/png"]').attr('srcset', justAnImage.img);
                                } else {
                                    context.find('.product-image-photo').attr('src', justAnImage.img);
                                    // context.find('[type="image/jpg"]').attr('srcset', justAnImage.img);
                                    // context.find('[type="image/png"]').attr('srcset', justAnImage.img);
                                }
                            });
                        } else {
                            ModernizrJajuma.on('webp', function (result) {
                                if (result) {
                                    // custom replace images with webp images
                                    self._convertOptimizeImage(images, context, isInProductView, justAnImage, 'webp');
                                    //Still need to update image/jpg here
                                    // context.find('[type="image/jpg"]').attr('srcset', justAnImage.img);
                                    // context.find('[type="image/png"]').attr('srcset', justAnImage.img);
                                } else {
                                    context.find('.product-image-photo').attr('src', justAnImage.img);
                                    // context.find('[type="image/jpg"]').attr('srcset', justAnImage.img);
                                    // context.find('[type="image/png"]').attr('srcset', justAnImage.img);
                                }
                            });
                        }
                    });
                }
            },

            /**
             * Add video events
             *
             * @param {Boolean} isInitial
             * @private
             */
            _addFotoramaVideoEvents: function (isInitial) {
                if (_.isUndefined($.mage.AddFotoramaVideoEvents)) {
                    return;
                }

                if (isInitial) {
                    $(this.options.mediaGallerySelector).AddFotoramaVideoEvents();

                    return;
                }

                $(this.options.mediaGallerySelector).AddFotoramaVideoEvents({
                    selectedOption: this.getProduct(),
                    dataMergeStrategy: this.options.gallerySwitchStrategy
                });
            },

            _getCurrentMediaCache: function () {
                let mediaCallData = {
                    'product_id': this.getProduct()
                };
                let mediaCacheKey = JSON.stringify(mediaCallData);
                let mediaCache = this.options.mediaCache[mediaCacheKey];
                let newImages = [];
                if (mediaCache && mediaCache.hasOwnProperty('gallery')) {
                    $.each(mediaCache.gallery, function () {
                        newImages.push({
                            full: this.large,
                            img: this.medium,
                            thumb: this.small,
                            isSmallImage: this.isSmallImage
                        });
                    });
                }
                return newImages;
            },

            _convertOptimizeImage: function (images, context, isInProductView, justAnImage, typeConvert, callback) {
                this._XhrKiller();
                var imageWidth = imageHeight = false;
                var gallery = context.find(this.options.mediaGallerySelector).data('gallery');
                var image = context.find('img');
                if (image) {
                    var imageWidth = (image.attr('max-width') === undefined) ? image.attr('width') : image.attr('max-width');
                    var imageHeight = (image.attr('max-height') === undefined) ? image.attr('height') : image.attr('max-height');
                }

                if (justAnImage.img.indexOf('.webp') !== -1) {
                    if (!isInProductView) {
                        context.find('[type="image/webp"]').attr('srcset', justAnImage.img);
                    }
                } else {
                    var convertEndpointUrl = 'rest/V1/uio/image/convert';
                    // add loading
                    if (isInProductView) {
                        // add loading for main .fotorama__active
                        $('.fotorama__stage .fotorama__img').addClass('swatch-option-loading-webp');

                        // add loading for thumb .fotorama__active
                        $('.fotorama__thumb img').addClass('swatch-option-loading-webp');
                    } else {
                        // add loading for main image in category page
                        context.find('.product-image-photo').addClass('swatch-option-loading-webp');
                    }
                    var currentMediaCache = this._getCurrentMediaCache();
                    $.each(images, function (idx, image) {
                        $.each(currentMediaCache, (_idx, _image) => {
                            if ((image.img == _image.img) && (_image.isSmallImage == true)){
                                images[idx].isSmallImage = true;
                            }
                        })
                        delete images[idx]['i'];
                    });
                    this.xhr = storage.post(
                        convertEndpointUrl,
                        JSON.stringify({
                            requestImages: {
                                images: images
                            },
                            isInProductView: isInProductView,
                            width: imageWidth,
                            height: imageHeight,
                            typeConvert: typeConvert
                        }),
                        false
                    ).done(
                        function (response) {
                            if (response.converted_urls.length != 0) {
                                // replace jpg/png image with webp image in category page only
                                if (!isInProductView) {
                                    // remove loading for main image in category page
                                    context.find('.product-image-photo').removeClass('swatch-option-loading-webp');

                                    // get webp image
                                    if (response.webp_resized_image_urls && Object.keys(response.webp_resized_image_urls).length > 0) {
                                        if (response.converted_urls[0]['img_webp']) {
                                            var webpSrcset = response.converted_urls[0]['img_webp'] + ' 1x, ';
                                            var endKey = Object.keys(response.webp_resized_image_urls).pop();
                                            $.each(response.webp_resized_image_urls, function (index, value) {
                                                let data = JSON.parse(value);
                                                if (index == endKey) {
                                                    //webpSrcset += value + ' ' + index + 'x';
                                                    webpSrcset += data.url + ' ' + data.ratio;
                                                } else {
                                                    //webpSrcset += value + ' ' + index + 'x, ';
                                                    webpSrcset += data.url + ' ' + data.ratio +', ';
                                                }
                                            });
                                        }
                                    } else {
                                        var webpSrcset = response.converted_urls[0]['img_webp'] ? response.converted_urls[0]['img_webp'] : false;
                                    }
                                    // load webp image
                                    if (webpSrcset) {
                                        context.find('[type="image/webp"]').attr('srcset', webpSrcset);

                                        // überschreibe das src des images mit dem webp srcset
                                        if (context.find('[type="image/webp"]').length == 0) {
                                            context.find('img.product-image-photo').attr('src', webpSrcset);
                                        }
                                    } else {
                                        //remove image/webp in case don't have image
                                        context.find('[type="image/webp"]').remove();
                                    }

                                    // get avif image
                                    if (response.avif_resized_image_urls && Object.keys(response.avif_resized_image_urls).length > 0) {
                                        if (response.converted_urls[0]['img_avif']) {
                                            var avifSrcset = response.converted_urls[0]['img_avif'] + ' 1x, ';
                                            var endKey = Object.keys(response.avif_resized_image_urls).pop();
                                            $.each(response.avif_resized_image_urls, function (index, value) {
                                                let data = JSON.parse(value);
                                                if (index == endKey) {
                                                    //avifSrcset += value + ' ' + index + 'x';
                                                    avifSrcset += data.url + ' ' + data.ratio;
                                                } else {
                                                    //avifSrcset += value + ' ' + index + 'x, ';
                                                    avifSrcset += data.url + ' ' + data.ratio +', ';
                                                }
                                            });
                                        }
                                    } else {
                                        var avifSrcset = response.converted_urls[0]['img_avif'] ? response.converted_urls[0]['img_avif'] : false;
                                    }
                                    // load avif image
                                    if (avifSrcset) {
                                        // if already exists <source type="image/avif">, we will replace "srcset"
                                        // else, we will add new <source type="image/avif">
                                        if (context.find('[type="image/avif"]').length == 0) {
                                            // replace srcset in <source type="image/avif">
                                            var html = $('<source type="image/avif" srcset="' + avifSrcset + '">');
                                            context.find('picture').prepend(html);
                                        } else {
                                            // add new <source type="image/avif">
                                            context.find('[type="image/avif"]').attr('srcset', avifSrcset);
                                        }
                                    } else {
                                        // remove <source type="image/avif">
                                        context.find('[type="image/avif"]').remove();
                                    }
                                    // get and load highres origin image
                                    if (response.origin_resized_image_urls && Object.keys(response.origin_resized_image_urls).length > 1) {
                                        var originSrcset = '';
                                        var endKey = Object.keys(response.origin_resized_image_urls).pop();
                                        $.each(response.origin_resized_image_urls, function (index, value) {
                                            let data = JSON.parse(value);
                                            if (index == endKey) {
                                                //originSrcset += value + ' ' + index + 'x';
                                                originSrcset += data.url + ' ' + data.ratio;
                                            } else {
                                                //originSrcset += value + ' ' + index + 'x, ';
                                                originSrcset += data.url + ' ' + data.ratio +', ';
                                            }
                                        });
                                    } else {
                                        originSrcset = '';
                                    }

                                    if (originSrcset) {
                                        context.find('[type="image/jpg"]').attr('srcset', originSrcset);
                                        context.find('[type="image/png"]').attr('srcset', originSrcset);
                                    } else {
                                        context.find('[type="image/jpg"]').remove();
                                        context.find('[type="image/png"]').remove();
                                    }
                                }

                                // replace jpg/png image with webp image in fotorama images in product page only
                                if (isInProductView) {
                                    // load image
                                    gallery.updateData(response.converted_urls);
                                    // remove loading for main .fotorama__active
                                    $('.fotorama__stage .fotorama__img').removeClass('swatch-option-loading-webp');
                                    // remove loading for thumb .fotorama__active
                                    $('.fotorama__thumb img').removeClass('swatch-option-loading-webp');
                                }
                            }
                        }
                    ).fail(
                        function (response) {
                            //console.log(response);
                        }
                    ).always(()=>{
                        if (typeof callback === 'function') {
                            callback();
                        }
                    });
                }
            }
        });

        return $.mage.SwatchRenderer;
    }
});

